import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

function FrequentlyAskedQuestions() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }
  };

  const answerVariants = {
    hidden: { height: 0, opacity: 0 },
    visible: { height: "auto", opacity: 1, transition: { duration: 0.4, ease: "easeOut" } },
    exit: { height: 0, opacity: 0, transition: { duration: 0.3, ease: "easeIn" } }
  };

  const faqData = [
    {
      left: [
        {
          question: "What isTechX Africa by ATC Africa??",
          answer:
            "This event unites a diverse community of tech leaders, professionals, and aspiring individuals from developers and designers to Web3 enthusiasts and product managers. Here, they'll share insights, build relationships, and delve into the forefront of African tech."
        },
        {
          question: "Why Should I attend?",
          answer: `If you're involved in innovation within technology, e-commerce, Web3, artificial intelligence and machine learning, content creation, gaming, promoting diversity, or related fields, ATC Africa offers a valuable opportunity to enhance your brand visibility and connect with a vibrant community of African tech professionals.

          This platform facilitates networking and learning from peers, industry leaders, and professionals, including small business owners. It provides a space to connect with potential partners and gain valuable insights for business growth.

          For startups and tech professionals, ATC Africa serves as a hub for discovering collaborations and expanding their networks.
          Tech enthusiasts can leverage this platform to explore the dynamic evolution of African technology and engage in insightful discussions by asking crucial questions within the ATC Africa community.`
        },
        {
          question: "Got a question that's not captured here?",
          answer: `Kindly Reach out to <strong>+234 907 902 1044</strong>
          or <strong>Hello@atcafrica.com</strong>
          Available to respond to messages`
        }
      ],
      right: [
        {
          question: "When is TechXAfrica happening?",
          answer:
            "TechX Africa is happening in Ibadan, Nigeria on 9th May 2025. We also have other exciting off-conference activities and Hackathon that'll happen during the week of the conference."
        },
        {
          question: "How can I prepare for the conference?",
          answer:
            "The very first thing to do is to save your seat by getting your ticket. Once your seat is secured, keep an eye out on our social pages and website as we'll be putting out content and information as the event approaches to help you prepare adequately."
        },
        {
          question: "How can my Startup/Company get involved as a sponsor?",
          answer:
            "If you'd like to be a sponsor or partner with us for TX Africa, send an email to partnershiptxa@atcafrica.com"
        },
        {
          question: "Who can Attend TechX Africa 25?",
          answer: `"Anyone is welcome to attend the conference, particularly those curious about the future of technology in Africa. 

          This year, we especially encourage the participation of young tech professionals, startups, and innovative entrepreneurs."`
        }
      ]
    }
  ];

  const renderFAQColumn = (faqs, colOffset) =>
    faqs.map((faq, index) => {
      const globalIndex = colOffset + index;
      const isOpen = openIndex === globalIndex;
      return (
        <motion.div
          key={globalIndex}
          variants={itemVariants}
          className="cursor-pointer mb-6"
        >
          {/* Question row */}
          <div
            className="flex justify-between items-center font-bold tracking-wide text-2xl max-lg:text-xl max-md:text-lg mb-4 bg-white p-3 rounded-lg shadow-sm border border-gray-300"
            onClick={() => toggleFAQ(globalIndex)}
          >
            <span>{faq.question}</span>
            <span className="text-3xl max-lg:text-2xl max-md:text-xl leading-none">
              {isOpen ? "−" : "+"}
            </span>
          </div>

          {/* Answer */}
          <AnimatePresence initial={false}>
            {isOpen && (
              <motion.div
                variants={answerVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                className="bg-[#F63A0A] p-5 border-4 rounded-lg border-black overflow-hidden"
              >
                {faq.answer.includes("<strong>") ? (
                  <p
                    className="text-white text-xl max-lg:text-lg max-md:text-base whitespace-pre-line leading-[1.8] tracking-[0.08em]"
                    dangerouslySetInnerHTML={{
                      __html: faq.answer.replace(/\n/g, "<br/>")
                    }}
                  />
                ) : (
                  <p className="font-small text-white text-xl max-lg:text-lg max-md:text-base whitespace-pre-line leading-[2.2] tracking-wide">
                    {faq.answer}
                  </p>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      );
    });


  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={containerVariants}
    >
      <div className="w-full h-fit flex flex-col gap-8 items-center justify-center py-12 bg-gray-50">
        <motion.h2
          variants={itemVariants}
          className="text-4xl max-lg:text-2xl max-md:text-xl font-semibold tracking-wide text-gray-800 border-b-4 border-gray-800 w-[85%] flex justify-center"
        >
          Frequently Asked Questions
        </motion.h2>

        <motion.div
          variants={containerVariants}
          className="w-[80%] mt-8 flex max-lg:flex-col justify-between mx-auto h-fit gap-0 md:gap-8"
        >
          {/* Left Column */}
          <motion.div
            variants={containerVariants}
            className="flex flex-col gap-0 md:gap-4 w-[48%] max-lg:w-full"
          >
            {renderFAQColumn(faqData[0].left, 0)}
          </motion.div>

          {/* Right Column */}
          <motion.div
            variants={containerVariants}
            className="flex flex-col gap-0 md:gap-4 w-[48%] max-lg:w-full"
          >
            {renderFAQColumn(faqData[0].right, faqData[0].left.length)}
          </motion.div>
        </motion.div>
      </div>
    </motion.div>

  );
}

export default FrequentlyAskedQuestions;
